/* eslint-disable
    @typescript-eslint/no-this-alias,
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { Analytics } from '@trello/atlassian-analytics';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

import { View } from 'app/scripts/views/internal/view';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import { PopoverSetListLimitTemplate } from 'app/scripts/views/templates/PopoverSetListLimitTemplate';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';

const WIP_LOWER_LIMIT = 0;
const WIP_UPPER_LIMIT = 5000;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const isValidListLimit = (value: any) =>
  value === null ||
  (!isNaN(value) && value >= WIP_LOWER_LIMIT && value <= WIP_UPPER_LIMIT);

interface ListSetLimitView {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  $el: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  model: any;
}

// @ts-expect-error TS(2707): Generic type 'View<TOptions, TModel>' requires bet... Remove this comment to see the full error message
class ListSetLimitView extends View {
  static initClass() {
    // @ts-expect-error TS(2339): Property 'viewTitleKey' does not exist on type 'Li... Remove this comment to see the full error message
    this.prototype.viewTitleKey = 'set list limit';

    // @ts-expect-error TS(2339): Property 'tagName' does not exist on type 'ListSet... Remove this comment to see the full error message
    this.prototype.tagName = 'form';

    // @ts-expect-error TS(2339): Property 'events' does not exist on type 'ListSetL... Remove this comment to see the full error message
    this.prototype.events = {
      'click .js-submit': 'submit',
      submit: 'submit',
      'click .js-remove-limit': 'removeLimit',
      'keyup .js-list-limit-input': 'limitChanged',
    };
  }

  initialize() {
    Analytics.sendScreenEvent({
      name: 'listLimitInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });
  }

  getValue() {
    const valueString = $('.js-list-limit-input', this.$el).val();

    // @ts-expect-error TS(2532): Object is possibly 'undefined'.
    if (!valueString.length) {
      return null;
    }

    // @ts-expect-error TS(2345): Argument of type 'string | number | string[] | und... Remove this comment to see the full error message
    return parseInt(valueString, 10);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  limitChanged(e: any) {
    const value = this.getValue();
    const isValid = isValidListLimit(value);

    $('.js-list-limit-input', this.$el).toggleClass('is-invalid', !isValid);
    // @ts-expect-error TS(2345): Argument of type 'boolean' is not assignable to pa... Remove this comment to see the full error message
    return $('.js-submit', this.$el).attr('disabled', !isValid);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  submit(e: any) {
    stopPropagationAndPreventDefault(e);

    const value = this.getValue();

    if (isValidListLimit(value)) {
      Analytics.sendTrackEvent({
        action: 'updated',
        actionSubject: 'listLimit',
        source: 'listLimitInlineDialog',
        attributes: {
          value,
        },
        containers: {
          list: {
            id: this.model.id,
          },
          board: {
            id: this.model.getBoard()?.id,
          },
          organization: {
            id: this.model.getBoard()?.getOrganization()?.id,
          },
        },
      });

      this.model.setSoftLimit(value);
      return PopOver.hide();
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  removeLimit(e: any) {
    stopPropagationAndPreventDefault(e);

    Analytics.sendTrackEvent({
      action: 'removed',
      actionSubject: 'listLimit',
      source: 'listLimitInlineDialog',
      containers: {
        list: {
          id: this.model.id,
        },
        board: {
          id: this.model.getBoard()?.id,
        },
        organization: {
          id: this.model.getBoard()?.getOrganization()?.id,
        },
      },
    });

    this.model.setSoftLimit(null);
    return PopOver.hide();
  }

  render() {
    const view = this;
    const { model } = view;

    const data = { limit: model.get('softLimit') };

    this.$el.html(PopoverSetListLimitTemplate(data));

    return this;
  }
}

ListSetLimitView.initClass();
export { ListSetLimitView };
